// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/PlusCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var PlusCircleTwoTone = function PlusCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleTwoToneSvg
  }));
};

PlusCircleTwoTone.displayName = 'PlusCircleTwoTone';
export default React.forwardRef(PlusCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PlusCircleTwoTone.js
// module id = 1593
// module chunks = 0